import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = { class: "table-header" }
const _hoisted_3 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_GenericTable = _resolveComponent("GenericTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", null, [
        _createElementVNode("label", null, [
          _createVNode(_component_font_awesome_icon, { icon: "search" }),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            placeholder: "検索フィルター",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterString) = $event))
          }, null, 512), [
            [_vModelText, _ctx.filterString]
          ])
        ]),
        (_ctx.newUri !== '')
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.newItem && _ctx.newItem(...args)))
            }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.newCaption), 1),
              _createVNode(_component_font_awesome_icon, { icon: "plus-circle" })
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_GenericTable, {
      items: _ctx.sortedAccounts,
      columns: _ctx.columns,
      keyProp: "slug",
      sortAsc: _ctx.sortAsc,
      onSort: _ctx.sortByNo,
      showIndex: true
    }, {
      email: _withCtx(({ item }) => [
        _createElementVNode("a", {
          href: `/accounts/${item.slug}`
        }, _toDisplayString(item.email), 9, _hoisted_3)
      ]),
      organizations: _withCtx(({ item }) => [
        _createTextVNode(_toDisplayString(Array.isArray(item.organizations)   ? item.organizations.join(', ') : item.organizations), 1)
      ]),
      _: 1
    }, 8, ["items", "columns", "sortAsc", "onSort"])
  ]))
}